module.exports = __webpack_public_path__ + "public/images/present.4905950174cd0d87ed536f973d4dfae0.svg";